import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useState } from "react";
import InputField from "../inputField/InputField";

export default function SetReminders() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  return (
    <div className="set_reminder mt-4">
      <h3>Receive a Reminder to Send Your Next Round of Letters</h3>
      <div className="date_area ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar />
        </LocalizationProvider>
        <hr />
        <form className="input_group mt-2">
          <InputField
            label="Email address:"
            value={email}
            onChange={handleEmailChange}
            type="email"
          />
          <div className="mt-3">
            <InputField
              label="Phone Number"
              value={phone}
              onChange={handlePhoneChange}
              type="tel"
            />
          </div>
          <button className="btn mt-4">Submit</button>
        </form>
      </div>
    </div>
  );
}
